import React from "react";
import { Modal, Button } from "react-bootstrap";
import FalconCloseButton from "components/common/FalconCloseButton";
import Flex from "components/common/Flex";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faExclamationTriangle } from "@fortawesome/free-solid-svg-icons";

const PaymentMultiClearErrorModal = ({ show, onClose }) => {
    return (
        <Modal show={show} onHide={onClose} centered>
            <Modal.Body className="p-4">
                <FalconCloseButton
                    onClick={onClose}
                    size="sm"
                    className="position-absolute top-0 end-0 me-2 mt-2"
                />
                <Flex direction="column" alignItems="center">
                    <div
                        className="rounded-circle bg-subtle-danger d-flex flex-center mb-3"
                        style={{ width: "60px", height: "60px" }}
                    >
                        <FontAwesomeIcon icon={faExclamationTriangle} className="text-danger fs-3" />
                    </div>
                    <h5 className="mb-2 text-danger">Action Restricted</h5>
                    <p className="text-center text-700 fs-10 mb-4">
                        Some of the selected payments do not have a <strong>"Paid"</strong> status.
                        Batch clearing is only permitted for payments that have already been processed and marked as Paid.
                        Please review your selection and try again.
                    </p>

                </Flex>
            </Modal.Body>
        </Modal>
    );
};

export default PaymentMultiClearErrorModal;
